import { Box, Col, FormGroup, Row } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils/validation';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';
import { getCountryName } from '@frontend/utils/countriesUtils';
import { TextInputField, TextInputFormGroup } from '../processActivityFormGroupFields';

export function AddressAddEditFormGroup(
    props: Readonly<{
        addressFieldKey: string;
        errors: ValidationErrors;
        isRequired: boolean;
    }>
) {
    const { addressFieldKey = 'patient', errors, isRequired } = props;

    const translate = getSelectedLanguage();

    return (
        <>
            <TextInputFormGroup
                fieldKey={`${addressFieldKey}.street`}
                isRequired={isRequired}
                label={translate.common.street}
                placeholder={translate.common.street}
            />

            <FormGroup
                hasErrors={
                    errors.has(`${addressFieldKey}.houseNumber`) ||
                    errors.has(`${addressFieldKey}.houseLetter`) ||
                    errors.has(`${addressFieldKey}.street`)
                }
                isRequired={isRequired}
                label={translate.common.houseNumberAndSuffix}
            >
                <Row
                    columnGap={[2, 4]}
                    rowGap={[2, 4]}
                >
                    <Col span={[12, null, 6]}>
                        <TextInputField
                            fieldKey={`${addressFieldKey}.houseNumber`}
                            placeholder={translate.common.houseNumber}
                        />
                    </Col>
                    <Col span={[6, null, 2]}>
                        <TextInputField
                            fieldKey={`${addressFieldKey}.houseLetter`}
                            placeholder={translate.common.houseLetter}
                        />
                    </Col>

                    <Col span={[6, null, 4]}>
                        <TextInputField
                            fieldKey={`${addressFieldKey}.houseNumberSuffix`}
                            placeholder={translate.common.houseNumberSuffix}
                        />
                    </Col>
                </Row>
            </FormGroup>

            <TextInputFormGroup
                fieldKey={`${addressFieldKey}.zip`}
                isRequired={isRequired}
                label={translate.common.zipcode}
                placeholder={translate.common.zipcode}
            />

            <TextInputFormGroup
                fieldKey={`${addressFieldKey}.city`}
                isRequired={isRequired}
                label={translate.common.city}
                placeholder={translate.common.city}
            />

            <Box marginBottom={4}>
                <FormParagraphFormGroup label={translate.common.country}>{getCountryName('NL')}</FormParagraphFormGroup>
            </Box>
        </>
    );
}
